export default __webpack_public_path__ + "static/media/Employees_Dynamic-Gait-Index.7711c105.pdf";